import { Box, Text, useTheme, VStack } from 'native-base';
import React, { useState } from 'react';
import { Platform, View } from 'react-native';
import { Callout } from 'react-native-maps';

import MapPin from 'app/components/icons/MapPin';

const PIN_SIZE = 30;

export type MapLocation = {
  title?: string;
  withOffset?: boolean;
  isDisabled?: boolean;

  // these are just needed for google-map-react (on web)
  lat?: number;
  lng?: number;
};

export default function MapLocation(props: MapLocation) {
  const theme = useTheme();
  const { title, isDisabled } = props;
  const [{ left, top }, setOffset] = useState({ left: 0, top: 0 });

  if (Platform.OS === 'android')
    return (
      <Callout testID="MapLocation" tooltip>
        <TextContent title={title} />
      </Callout>
    );

  return (
    <View
      style={{ transform: [{ translateX: left }, { translateY: top }], position: 'absolute' }}
      testID="MapLocation"
      onLayout={(e) => {
        const { width, height } = e.nativeEvent.layout;
        setOffset({
          left: width ? -width / 2 : 0,
          top: height ? -height : 0,
        });
      }}
    >
      <VStack alignItems="center" space={1}>
        <TextContent title={title} />
        <MapPin color={isDisabled ? theme.colors.brand.disabled : 'black'} size={PIN_SIZE} />
      </VStack>
    </View>
  );
}

function TextContent({ title }: { title?: string }) {
  return title ? (
    <Box bgColor="white" flex="1" px="1.5" py="1" rounded="sm" shadow="5">
      <Text
        alignSelf="flex-start"
        bold
        flex="1"
        flexWrap="wrap"
        fontSize="xs"
        letterSpacing={0}
        lineHeight="xs"
        maxWidth="100px"
        textAlign="center"
      >
        {title.trim()}
      </Text>
    </Box>
  ) : null;
}
